import { EventsSection } from './MainPageSections/EventsSection/EventsSection';
import { IntroSection } from './MainPageSections/IntroSection/IntroSection';
import { NewsSection } from './MainPageSections/NewsSection/NewsSection';
import { PartnersSection } from './MainPageSections/PartnersSection/PartnersSection';
import { UsefulSection } from './MainPageSections/UsefulSection/UsefulSection';
import { VacanciesSection } from './MainPageSections/VacanciesSection/VacanciesSection';

export const MainPage = () => {
    return (
        <>
            {/* полосы чередуются серая/белая, см. PROJECT.md: вступление серое,
                новости белые, «Полезное» серое, календарь белый, вакансии серые,
                партнёры белые. Пока ни один материал не отмечен «На главную»,
                блока «Полезного» нет, и новости с календарём идут одной белой полосой */}
            <IntroSection />
            <NewsSection />
            <UsefulSection />
            <EventsSection />
            <VacanciesSection />
            <PartnersSection />
        </>
    );
};
